import axios from 'axios'
import { useStorage } from '@/composables/useStorage'

export const useApi = () => {
   const { email, token, getKeycloackToken, getDelegacao } = useStorage()

   const api = axios.create({
      baseURL: `${process.env.VUE_APP_API}`,
      withCredentials: false,
      headers: {
         Authorization: email !== null ? '' : `Bearer ${getKeycloackToken}`,
         TenantId: `${process.env.VUE_APP_TENANTID}`,
         Delegacao: `${getDelegacao}`,
         EmailAuth: `${email}`,
         TokenAuth: `${token}`,
         'Content-Type': 'application/json'
      }
   })

   return { api }
}
